import { NgModule } from '@angular/core';
import { Routes, RouterModule } from '@angular/router';
import { ProjectGanttChartComponent } from './project-gantt-chart.component';

const routes: Routes = [
  {
    path: '',
    component: ProjectGanttChartComponent
  }
];

@NgModule({
  imports: [RouterModule.forChild(routes)],
  exports: [RouterModule]
})
export class ProjectGanttChartRoutingModule { }
